import { take, call, put, fork } from 'redux-saga/effects';
import fetchApi from '../../../../../utils/fetchApi';

function* getAllProductMetasFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter }, next } = yield take('GET_PRODUCT_METAS');
    try {
      const response = yield call(fetchApi, `Products?filter=${JSON.stringify(filter)}`);
      if (response && !response.error) {
        yield put({ type: 'GET_PRODUCT_METAS_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

function* getPaymentReportFlow() {
  const INFINITE = true;

  while (INFINITE) {
    const { payload: { filter, accountId }, next } = yield take('GET_PAYMENT_REPORT');
    try {
      const response = yield call(fetchApi, `Accounts/${accountId}/billings?filter=${JSON.stringify(filter)}`);
      if (response && !response.error) {
        yield put({ type: 'GET_PAYMENT_REPORT_SUCCESS', payload: response });
        if (next && typeof next === 'function') {
          next();
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err });
    }
  }
}

export default function* dashboardFlow() {
  yield fork(getAllProductMetasFlow);
  yield fork(getPaymentReportFlow);
}



// WEBPACK FOOTER //
// ./routes/app/routes/dashboard/saga/index.js